var cpu = "https://shopfront-cdn.tekoapis.com/static/a4b4d772feed1003.svg";

export { cpu as default };
